import styled from 'styled-components';

const Balance = styled.span`
	display: inline-block;
	margin-top: 12px;
	color: var(--color-text);
	font-size: 36px;
	width: 100%;
	text-align: center;
`;

export default Balance;
